import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { useToast } from '@/components/ui/use-toast';
import { 
  Search, 
  UserPlus, 
  ChevronUp, 
  ChevronDown, 
  Lock, 
  LockOpen, 
  Trash2, 
  Download, 
  Edit, 
  RefreshCw
} from 'lucide-react';
import { memberships } from '@/data/memberships';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { 
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { Progress } from "@/components/ui/progress";
import { useAuth, User, CourseProgress } from '@/contexts/MyContext';

const userFormSchema = z.object({
  name: z.string().min(2, {
    message: "Name must be at least 2 characters.",
  }),
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
  password: z.string().min(6, {
    message: "Password must be at least 6 characters.",
  }).optional().or(z.literal('')),
});

interface UserManagerProps {
  refreshUsers?: () => void;
}

const UserManager: React.FC<UserManagerProps> = ({ refreshUsers }) => {
  // const { getAllUsers, addUserMembership, removeUserMembership, setUserLocked, deleteUser } = useAuth();
  const {getAllUsers} = useAuth();
  const [users, setUsers] = useState<{email: string, full_name: string, id: string}[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedUser, setExpandedUser] = useState<string | null>(null);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);
  const [isEditUserOpen, setIsEditUserOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { toast } = useToast();

  const form = useForm<z.infer<typeof userFormSchema>>({
    resolver: zodResolver(userFormSchema),
    defaultValues: {
      name: "",
      email: "",
      password: "",
    },
  });

  // const loadUsers = async() => {
  //   try {
  //     const rawUsers = localStorage.getItem("allUsers");
  //     if (rawUsers) {
  //       try {
  //         const parsedUsers = JSON.parse(rawUsers);
  //         setUsers(parsedUsers);
  //         console.log("UserManager - Direct localStorage load - User count:", parsedUsers.length, 
  //           "User emails:", parsedUsers.map((u: User) => u.email).join(', '));
  //       } catch (e) {
  //         console.error("Error parsing users from localStorage", e);
  //       }
  //     } else {
  //       const allUsers = await getAllUsers();
  //       setUsers(allUsers);
  //       console.log("UserManager - Context method load - User count:", allUsers.length);
  //     }
  //   } catch (error) {
  //     console.error("Error loading users:", error);
  //   }
  // };
useEffect(()=>{
  (async()=>{
    const allUsers = await getAllUsers();
    setUsers(allUsers);
    console.log(allUsers, 'all users data');
  })()
},[])
  const handleManualRefresh = async() => {
    setIsRefreshing(true);
    
    // loadUsers();
    
    
    if (refreshUsers) {
      refreshUsers();
    }
    
    setTimeout(() => {
      setIsRefreshing(false);
      toast({
        title: "User Data Refreshed",
        description: "User list has been refreshed from storage",
      });
    }, 500);
  };

  // useEffect(() => {
  //   loadUsers();
    
  //   const interval = setInterval(() => {
  //     loadUsers();
  //   }, 1000);
    
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    if (currentUser && isEditUserOpen) {
      form.reset({
        name: currentUser.name,
        email: currentUser.email,
        password: "",
      });
    }
  }, [currentUser, isEditUserOpen, form]);
console.log(users, 'users')
  // const filteredUsers = users.filter(user => 
  //   user?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   user?.email.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const toggleUserExpand = (userId: string) => {
    setExpandedUser(expandedUser === userId ? null : userId);
  };

  // const upgradeMembership = (userId: string, membershipId: string) => {
  //   addUserMembership(userId, membershipId);
    
  //   const allUsers = JSON.parse(localStorage.getItem("allUsers") || "[]");
  //   const userIndex = allUsers.findIndex((u: User) => u.id === userId);
    
  //   if (userIndex >= 0) {
  //     if (!allUsers[userIndex].memberships) {
  //       allUsers[userIndex].memberships = [];
  //     }
      
  //     if (!allUsers[userIndex].memberships.includes(membershipId)) {
  //       allUsers[userIndex].memberships.push(membershipId);
  //     }
      
  //     localStorage.setItem("allUsers", JSON.stringify(allUsers));
  //   }
    
  //   handleManualRefresh();
    
  //   const updatedUsers = getAllUsers();
  //   const updatedUser = updatedUsers.find(u => u.id === userId);
    
  //   console.log("User memberships updated:", updatedUser);
    
  //   const membershipName = memberships.find(m => m.id === membershipId)?.name || membershipId;
  //   const userName = updatedUser?.name || "User";
    
  //   toast({
  //     title: "Membership Added Successfully",
  //     description: `${membershipName} has been added to ${userName}. Course content is now available.`,
  //   });
  // };

  // const revokeMembership = (userId: string, membershipId: string) => {
  //   removeUserMembership(userId, membershipId);
    
  //   const allUsers = JSON.parse(localStorage.getItem("allUsers") || "[]");
  //   const userIndex = allUsers.findIndex((u: User) => u.id === userId);
    
  //   if (userIndex >= 0 && allUsers[userIndex].memberships) {
  //     allUsers[userIndex].memberships = allUsers[userIndex].memberships.filter(
  //       (id: string) => id !== membershipId
  //     );
  //     localStorage.setItem("allUsers", JSON.stringify(allUsers));
  //   }
    
  //   handleManualRefresh();
    
  //   const membershipName = memberships.find(m => m.id === membershipId)?.name || membershipId;
    
  //   toast({
  //     title: "Membership Revoked",
  //     description: `${membershipName} membership successfully removed from user.`,
  //   });
  // };

  // const toggleLockUser = (userId: string, currentLockedState: boolean) => {
  //   setUserLocked(userId, !currentLockedState);
    
  //   setUsers(getAllUsers());
    
  //   toast({
  //     title: currentLockedState ? "User Unlocked" : "User Locked",
  //     description: currentLockedState 
  //       ? "The user can now access their account." 
  //       : "The user account has been locked and they have been logged out.",
  //   });
  // };

  // const handleDeleteUser = (userId: string) => {
  //   deleteUser(userId);
    
  //   setUsers(getAllUsers());
  // };

  const handleAddUser = () => {
    setCurrentUser(null);
    form.reset({
      name: "",
      email: "",
      password: "",
    });
    setIsAddUserOpen(true);
  };

  const handleEditUser = (user: User) => {
    setCurrentUser(user);
    setIsEditUserOpen(true);
  };

  const onSubmitAddUser = (values: z.infer<typeof userFormSchema>) => {
    const { password, ...userData } = values;
    
    const newUser: User = {
      id: Date.now().toString(),
      name: userData.name,
      email: userData.email,
      // memberships: [],
      // locked: false,
      // courseProgress: []
    };
    
    const currentUsers = JSON.parse(localStorage.getItem("allUsers") || "[]");
    
    const emailExists = currentUsers.some((user: User) => 
      user.email.toLowerCase() === newUser.email.toLowerCase()
    );
    
    if (emailExists) {
      toast({
        title: "Error Adding User",
        description: "A user with this email already exists.",
        variant: "destructive",
      });
      return;
    }
    
    const updatedUsers = [...currentUsers, newUser];
    localStorage.setItem("allUsers", JSON.stringify(updatedUsers));
    
    setUsers(updatedUsers);
    
    if (password && password.trim() !== '') {
      const userPasswords = JSON.parse(localStorage.getItem("userPasswords") || "{}");
      userPasswords[newUser.email.toLowerCase()] = password;
      localStorage.setItem("userPasswords", JSON.stringify(userPasswords));
    }
    
    setIsAddUserOpen(false);
    handleManualRefresh();
    
    toast({
      title: "User Added",
      description: `${values.name} has been added successfully.`,
    });
    
    console.log("New user added:", newUser, "Total users:", updatedUsers.length);
  };

  const onSubmitEditUser = (values: z.infer<typeof userFormSchema>) => {
    if (!currentUser) return;
    
    const { password, ...userData } = values;
    
    const currentUsers = JSON.parse(localStorage.getItem("allUsers") || "[]");
    
    const updatedUsers = currentUsers.map((user: User) => {
      if (user.id === currentUser.id) {
        return {
          ...user,
          name: userData.name,
          email: userData.email
        };
      }
      return user;
    });
    
    localStorage.setItem("allUsers", JSON.stringify(updatedUsers));
    
    setUsers(updatedUsers);
    
    if (password && password.trim() !== '') {
      const userPasswords = JSON.parse(localStorage.getItem("userPasswords") || "{}");
      userPasswords[userData.email.toLowerCase()] = password;
      localStorage.setItem("userPasswords", JSON.stringify(userPasswords));
    }
    
    setIsEditUserOpen(false);
    handleManualRefresh();
    
    toast({
      title: "User Updated",
      description: `${values.name} has been updated successfully.`,
    });
  };

  const exportUsers = () => {
    const headers = ['Name', 'Email', 'Memberships', 'Status', 'Created Date'];
    const csvRows = [
      headers.join(','),
      ...users.map(user => [
        user.full_name,
        user.email,
        // user.memberships.join(';'),
        // user.locked ? 'Locked' : 'Active',
        'N/A'
      ].join(','))
    ];
    
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    const dateStr = new Date().toISOString().split('T')[0];
    link.setAttribute('href', url);
    link.setAttribute('download', `users_export_${dateStr}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast({
      title: "Export Complete",
      description: `All users have been exported to a CSV file.`,
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">User Management</h2>
        <Button 
          variant="outline" 
          size="sm"
          onClick={handleManualRefresh}
          disabled={isRefreshing}
        >
          <RefreshCw className={`h-4 w-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} />
          Refresh Users
        </Button>
      </div>

      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2 flex-1 max-w-md">
          <Search className="h-5 w-5 text-gray-400" />
          <Input 
            placeholder="Search users by name or email..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="space-x-2">
          <Button onClick={exportUsers}>
            <Download className="mr-2 h-4 w-4" /> Export Users
          </Button>
          <Button onClick={handleAddUser}>
            <UserPlus className="mr-2 h-4 w-4" /> Add New User
          </Button>
        </div>
      </div>
      
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-10"></TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Memberships</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((user) => (
              <React.Fragment key={user.id}>
                <TableRow>
                  <TableCell>
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      onClick={() => toggleUserExpand(user.id)}
                    >
                      {expandedUser === user.id ? 
                        <ChevronUp className="h-4 w-4" /> : 
                        <ChevronDown className="h-4 w-4" />
                      }
                    </Button>
                  </TableCell>
                  <TableCell className="font-medium">{user.full_name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    <div className="flex flex-wrap gap-1">
                      {/* {user.memberships.map((membershipId) => {
                        const membership = memberships.find(m => m.id === membershipId);
                        return (
                          <Badge key={membershipId} variant="outline">
                            {membership ? membership.name : membershipId}
                          </Badge>
                        );
                      })}
                      {user.memberships.length === 0 && (
                        <span className="text-gray-500 text-sm">No active memberships</span>
                      )} */}
                    </div>
                  </TableCell>
                  {/* <TableCell>
                    {user.locked ? (
                      <Badge variant="destructive" className="flex items-center">
                        <Lock className="h-3 w-3 mr-1" /> Locked
                      </Badge>
                    ) : (
                      <Badge variant="outline" className="flex items-center text-green-600 border-green-600">
                        <LockOpen className="h-3 w-3 mr-1" /> Active
                      </Badge>
                    )}
                  </TableCell> */}
                  {/* <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button 
                        variant="outline" 
                        size="sm"
                        onClick={() => handleEditUser(user)}
                      >
                        <Edit className="h-4 w-4 mr-1" /> Edit
                      </Button>
                      
                      <Select 
                        onValueChange={(value) => upgradeMembership(user.id, value)}
                      >
                        <SelectTrigger className="w-32">
                          <SelectValue placeholder="Add..." />
                        </SelectTrigger>
                        <SelectContent>
                          {memberships.map((membership) => (
                            <SelectItem 
                              key={membership.id} 
                              value={membership.id}
                              disabled={user.memberships.includes(membership.id)}
                            >
                              {membership.name}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      
                      <Select 
                        onValueChange={(value) => revokeMembership(user.id, value)}
                        disabled={user.memberships.length === 0}
                      >
                        <SelectTrigger className="w-32">
                          <SelectValue placeholder="Remove..." />
                        </SelectTrigger>
                        <SelectContent>
                          {user.memberships.map((membershipId) => {
                            const membership = memberships.find(m => m.id === membershipId);
                            return (
                              <SelectItem key={membershipId} value={membershipId}>
                                {membership ? membership.name : membershipId}
                              </SelectItem>
                            );
                          })}
                        </SelectContent>
                      </Select>
                      
                      <Button 
                        variant={user.locked ? "outline" : "destructive"} 
                        size="sm"
                        onClick={() => toggleLockUser(user.id, user.locked)}
                      >
                        {user.locked ? (
                          <>
                            <LockOpen className="h-4 w-4 mr-1" /> Unlock
                          </>
                        ) : (
                          <>
                            <Lock className="h-4 w-4 mr-1" /> Lock
                          </>
                        )}
                      </Button>

                      <Button 
                        variant="destructive" 
                        size="sm"
                        onClick={() => handleDeleteUser(user.id)}
                      >
                        <Trash2 className="h-4 w-4 mr-1" /> Delete
                      </Button>
                    </div>
                  </TableCell> */}
                </TableRow>
                {expandedUser === user.id && (
                  <TableRow>
                    <TableCell colSpan={6} className="bg-slate-50 py-4">
                      <div className="px-4">
                        <h4 className="font-semibold mb-2 text-sm">Course Progress</h4>
                        {/* {user.courseProgress && user.courseProgress.length > 0 ? (
                          <div className="space-y-4">
                            {user.courseProgress.map((course) => (
                              <div key={course.courseId} className="bg-white p-3 rounded-md border">
                                <div className="flex justify-between items-center mb-2">
                                  <span className="font-medium">{course.courseName}</span>
                                  <Badge>{course.percentage}% Complete</Badge>
                                </div>
                                <Progress value={course.percentage} className="h-2" />
                                <p className="text-xs text-gray-500 mt-2">
                                  {course.completedItems} of {course.totalItems} lessons completed
                                </p>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-gray-500 text-sm">No course progress data available</p>
                        )} */}
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
            {users.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-8 text-gray-500">
                  No users found matching your search
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      
      <Dialog open={isAddUserOpen} onOpenChange={setIsAddUserOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Add New User</DialogTitle>
            <DialogDescription>
              Enter the details of the new user to add them to the system.
            </DialogDescription>
          </DialogHeader>
          
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmitAddUser)} className="space-y-4">
              <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name</FormLabel>
                    <FormControl>
                      <Input placeholder="Full name" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Email</FormLabel>
                    <FormControl>
                      <Input placeholder="Email address" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="password"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Password</FormLabel>
                    <FormControl>
                      <Input 
                        type="password" 
                        placeholder="Password for login" 
                        {...field} 
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              
              <DialogFooter>
                <Button type="submit">Add User</Button>
              </DialogFooter>
            </form>
          </Form>
        </DialogContent>
      </Dialog>
      
      <Dialog open={isEditUserOpen} onOpenChange={setIsEditUserOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Edit User</DialogTitle>
            <DialogDescription>
              Update the details of this user.
            </DialogDescription>
          </DialogHeader>
          
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmitEditUser)} className="space-y-4">
              <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name</FormLabel>
                    <FormControl>
                      <Input placeholder="Full name" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Email</FormLabel>
                    <FormControl>
                      <Input placeholder="Email address" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="password"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Password (leave blank to keep unchanged)</FormLabel>
                    <FormControl>
                      <Input 
                        type="password" 
                        placeholder="New password" 
                        {...field} 
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              
              <DialogFooter>
                <Button type="submit">Update User</Button>
              </DialogFooter>
            </form>
          </Form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UserManager;
